import { get, post } from "@/utils/http";
// import contentType from "@/utils/content-type";

let personalURL = "/personal";

// 查询所有用户信息
const findQuery = data => post(`${personalURL}/findQuery`, { data });

// 添加/编辑用户信息
const createPersonal = data => post(`${personalURL}/createPersonal`, { data });
// 添加/编辑用户信息
const updatePersonal = data => post(`${personalURL}/updatePersonal`, { data });
// 删除用户信息
const deletePersonal = data => post(`${personalURL}/deletePersonal`, { data });


// personalAPI
export default {
  findQuery,
  createPersonal,
  updatePersonal,
  deletePersonal,
};
